module.exports = __webpack_public_path__ + "assets/2a95170f46cee838e69c90267460a0be.png";